"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchDocumentsCountQuery = exports.useSearchDocumentsQuery = exports.searchV2Api = exports.transformItemsResponseV2 = exports.initialTransformedData = void 0;
// import { paramAsString } from '@common/services/util/params';
var jobItemHistory_1 = require("@utils/jobItemHistory");
var job_1 = __importDefault(require("@common/model/job"));
var baseApi_1 = require("./baseApi");
exports.initialTransformedData = {
    total: 0,
    currentItemOffsetInDecimal: 0,
    items: [],
    currentPage: 0,
    isPreviousDisabled: true,
    isNextDisabled: false,
    perPage: 20,
};
// Job is not serializable we can't store them in the store
var transformItemsResponseV2 = function (response, queues, currentPage, total, perPage) {
    var offset = currentPage === 0 ? 0 : perPage * currentPage;
    return {
        items: response.items.map(function (item) {
            var job = new job_1.default({ ad: item });
            var historyItem = item.history && Array.isArray(item.history) && item.history[0];
            if (historyItem) {
                job.queueName = (0, jobItemHistory_1.getCurrentQueueName)(historyItem, queues);
            }
            return job;
        }),
        currentItemOffsetInDecimal: offset,
        currentPage: currentPage,
        total: total,
        isPreviousDisabled: currentPage === 0,
        isNextDisabled: offset + response.items.length >= total,
        perPage: perPage,
    };
};
exports.transformItemsResponseV2 = transformItemsResponseV2;
// Define a service using a base URL and expected endpoints
exports.searchV2Api = baseApi_1.baseApi.injectEndpoints({
    endpoints: function (builder) { return ({
        searchDocuments: builder.query({
            query: function (_a) {
                var domain = _a.domain, rest = __rest(_a, ["domain"]);
                return ({
                    url: "/sites/".concat(domain, "/ads/v2/search"),
                    method: 'POST',
                    // Our axiosBaseQuery is using data not body I spend too much time on that
                    data: rest,
                });
            },
        }),
        searchDocumentsCount: builder.query({
            query: function (_a) {
                var domain = _a.domain, rest = __rest(_a, ["domain"]);
                return ({
                    url: "/sites/".concat(domain, "/ads/v2/count"),
                    method: 'POST',
                    data: rest,
                });
            },
        }),
    }); },
});
exports.useSearchDocumentsQuery = exports.searchV2Api.useSearchDocumentsQuery, exports.useSearchDocumentsCountQuery = exports.searchV2Api.useSearchDocumentsCountQuery;
